<template>
  <footer class="bg-gray-800 border-t border-gray-700 font-mono mt-4">
    <div class="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">

      <!-- Company Address -->
      <div class="text-center mb-2">
        <div class="text-gray-500 text-sm leading-relaxed">
          <p class="font-bold">BF2 LLC</p>
          2382 Camino Vida Roble, Suite I<br>
          Carlsbad, CA 92011, United States
        </div>
      </div>

      <!-- Copyright -->
      <div class="text-center  mb-2">
        <p class="text-gray-500 text-sm">
          All Rights Reserved
        </p>
      </div>

       <!-- Links -->
       <div class="flex justify-center items-center">
        <div class="text-gray-400 text-sm font-medium">
          <a href="https://altcoinalert.com/privacy-policy" target="_blank" rel="noopener noreferrer" class="text-gray-400 hover:text-white transition duration-150 ease-in-out">
            Privacy Policy
          </a>
          <span class="mx-2">|</span>
          <a href="https://altcoinalert.com/terms-of-service" target="_blank" rel="noopener noreferrer" class="text-gray-400 hover:text-white transition duration-150 ease-in-out">
            Terms of Service
          </a>
          <span class="mx-2">|</span>
          <a href="https://altcoinalert.com/contact-support" target="_blank" rel="noopener noreferrer" class="text-gray-400 hover:text-white transition duration-150 ease-in-out">
            Contact
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
}
</script>
